module.exports = __webpack_public_path__ + "static/media/charge_bomb.439008cb.png";